import { ShieldCheck } from "lucide-react";

/**
 * Founder-credibility block shown on the homepage in place of a client testimonial.
 *
 * NOTE: The commented placeholder below marks where a real, attributed client
 * testimonial should be added once one is collected. Do not invent quotes.
 */
const PracticeCredibility = () => (
  <section className="py-20 md:py-28 bg-accent/50">
    <div className="container">
      <div className="max-w-2xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-warm/15 mb-6">
          <ShieldCheck className="h-5 w-5 text-warm" aria-hidden />
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold mb-4">The Kinship Standard</h2>
        <div className="w-12 h-px bg-warm mx-auto mb-6" />
        <p className="text-foreground/80 text-lg font-light leading-relaxed">
          Every senior companion caregiver is personally vetted, background-checked, and reference-verified before they
          ever step into a client's home — and matched to your family rather than assigned to a shift. It's a small,
          boutique practice, which means the same standard of care in every home, every visit.
        </p>
        <ul className="mt-8 grid gap-3 sm:grid-cols-3 text-sm text-foreground/75">
          <li className="rounded-xl border border-warm/25 bg-background/60 px-4 py-3">
            Background-checked, reference-verified senior caregivers
          </li>
          <li className="rounded-xl border border-warm/25 bg-background/60 px-4 py-3">
            One consistent companion — matched, never assigned
          </li>
          <li className="rounded-xl border border-warm/25 bg-background/60 px-4 py-3">
            Serving Nashville, Brentwood, Franklin &amp; Belle Meade
          </li>
        </ul>
      </div>

      {/* ---------------------------------------------------------------
          PLACEHOLDER — real client testimonial goes here.
          Replace this block with a genuine, attributed quote (name,
          city, and permission on file). Never publish invented reviews.
      ---------------------------------------------------------------- */}
    </div>
  </section>
);

export default PracticeCredibility;
